import { useEffect, useMemo, useState } from "react";
import { Card } from "antd";
import { useAppDispatch } from "Store/hooks";
import { setActiveKey } from "Layout/redux/slice";
import "./Exceptions.index.css";
import { getExceptions } from "./redux/thunks";
import ExceptionTable from "./table/table.index";
import { useSelector } from "react-redux";
import { selectExceptionData } from "./redux/selectors";
import ExceptionToolbar from "./toolbar/ExceptionToolbar";
import { setLoadingState } from "Features/Auth/redux/slice";
const Exceptions = () => {
  const dispatch = useAppDispatch();

  const exceptionData = useSelector(selectExceptionData);
  const [searchText, setSearchText] = useState("");

  const filteredData = useMemo(() => {
    if (!searchText || searchText === "") return exceptionData;

    const text = searchText.toLowerCase();
    return exceptionData.filter((item: any) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(text)
      )
    );
  }, [exceptionData, searchText]);

  useEffect(() => {
    dispatch(setLoadingState(true));
    dispatch(setActiveKey(["exceptions"]));
    dispatch(getExceptions())
      .unwrap()
      .catch((err: any) => {
        dispatch(setLoadingState(false));
        console.log(err);
      })
      .finally(() => {
        dispatch(setLoadingState(false));
      });

    const interval = setInterval(() => {
      dispatch(getExceptions());
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="exceptions-container">
      <Card className="exceptions-scrollable-wrapper">
        <ExceptionToolbar onSearch={setSearchText} />
        <div className="table-scroll-container">
          <ExceptionTable data={filteredData} />
        </div>
      </Card>
    </div>
  );
};

export default Exceptions;
